import {useDispatch} from "react-redux";

import {
  getOptionsData,
  getListData,
  setDownloadData,
  getAffiliatesData,
  getTrackersData,
  getDealsData,
  getCreativesData,
  getColumnsData,
  clearDownload,
  clearListState,
  clearAffiliatesState,
  clearTrackersState,
  clearColumnsState,
  reset,
} from "./index";

export const useCreativeReport = () => {
  const dispatch = useDispatch();

  const getOptions = () => dispatch(getOptionsData());
  const getColumns = () => dispatch(getColumnsData());
  const getList = (data: any) => dispatch(getListData(data));
  const getAffiliates = (data: any) => dispatch(getAffiliatesData(data));
  const getTrackers = (data: any) => dispatch(getTrackersData(data));
  const getCreatives = (data: any) => dispatch(getCreativesData(data));
  const getDeals = () => dispatch(getDealsData());
  const setDownload = (data: any) => dispatch(setDownloadData(data));

  const clearListData = () => dispatch(clearListState());
  const resetState = () => dispatch(reset());
  const clearDownloadState = () => dispatch(clearDownload());
  const clearAffiliates = () => dispatch(clearAffiliatesState());
  const clearTrackers = () => dispatch(clearTrackersState());
  const clearColumns = () => dispatch(clearColumnsState());

  return {
    getOptions,
    getList,
    setDownload,
    clearDownloadState,
    clearListData,
    resetState,
    getAffiliates,
    clearAffiliates,
    getTrackers,
    clearTrackers,
    getDeals,
    getCreatives,
    getColumns,
    clearColumns,
  }
}
